<template>
  <div>
    <Header />

    <Contents />

    <Footer />
  </div>
</template>

<script>
import Header from "../../components/private/Header";
import Contents from "./components/Contents.vue";
import Footer from "../../components/layout/Footer.vue";

export default {
  components: {
    Header,
    Contents,
    Footer,
  },
  mounted() {
    this.$store.commit("setPrivateView", "portada-bgi");
  },
};
</script>

<style scoped>
.main {
  background: #fff;
  display: grid;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

h4 {
  text-align: center;
  color: #052333;
  font-weight: bold;
}
</style>
